import { site, legalNotice } from "../data/site";
import { navItems, routeToPath, onNavClick } from "../router";

const entries = navItems.slice(1);

export function HomePage({ onNavigate }: { onNavigate: (route: string) => void }) {
  return (
    <main className="page home-page">
      <section className="console-hero" aria-label={`${site.name}首页`}>
        <div className="console-hero-copy">
          <p className="console-kicker">TENGYUNZI BAZI STUDIO</p>
          <h1>{site.name}</h1>
          <p>
            用清晰的四柱、年份资料、合化关系和案例记录，把传统文化内容整理成可追踪、可复盘的学习流程。
          </p>
          <div className="console-hero-actions">
            <a href={routeToPath("paipan")} onClick={(e) => onNavClick(e, "paipan", onNavigate)}>
              开始排盘
            </a>
            <a href={routeToPath("records")} onClick={(e) => onNavClick(e, "records", onNavigate)}>
              查看记录案例
            </a>
          </div>
        </div>
      </section>

      <section className="home-entries">
        <h2>功能入口</h2>
        <div className="entry-grid">
          {entries.map((item) => (
            <a
              key={item.key}
              href={routeToPath(item.key)}
              onClick={(e) => onNavClick(e, item.key, onNavigate)}
            >
              {item.label}
            </a>
          ))}
        </div>
      </section>

      <p className="home-notice">{legalNotice}</p>
    </main>
  );
}
